import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import FiltersService from '../../services/FiltersService';

export const filterKeys = {
  all: ['filters'],
  byGender: (gender) => [...filterKeys.all, 'gender', gender],
  byGenderFilter: (gender) => [...filterKeys.all, 'genderfilter', gender],
};

export function useFiltersByGender(gender) {
  return useQuery({
    enabled: !!gender,
    queryKey: filterKeys.byGender(gender),
    queryFn: async () => {
      const filtersData = await FiltersService.listFiltersGender(gender);

      const middle = Math.ceil(filtersData.length / 2);

      return {
        leftColumn: filtersData.slice(0, middle),
        rightColumn: filtersData.slice(middle),
        all: filtersData,
      };
    },
  });
}

export function useFiltersByGenderFilter(gender, enabled = true) {
  return useQuery({
    enabled: !!gender && enabled,
    queryKey: filterKeys.byGenderFilter(gender),
    queryFn: async () => {
      const filtersData = await FiltersService.listFiltersGenderFilter(gender);

      const middle = Math.ceil(filtersData.length / 2);

      return {
        leftColumn: filtersData.slice(0, middle),
        rightColumn: filtersData.slice(middle),
        all: filtersData,
      };
    },
  });
}

// Adicionar ao arquivo existente

/**
 * Hook para buscar filtros da model
 */
export function useModelFilters() {
  return useQuery({
    queryKey: [...filterKeys.all, 'model'],
    queryFn: () => FiltersService.getModelFilters(),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Hook para salvar filtro da model
 */
export function useUpsertModelFilter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (filterData) => FiltersService.upsertModelFilter(filterData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...filterKeys.all, 'model'] });
    },
  });
}

/**
 * Hook para deletar filtro da model
 */
export function useDeleteModelFilter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (filterId) => FiltersService.deleteModelFilter(filterId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...filterKeys.all, 'model'] });
    },
  });
}
